__webpack_require__.p = "/apps/nextcloudpi/js/";